'use client'

import { type ReactNode } from 'react'

import { Box, Container, Image } from '@doist/marketist'

import { addProtocol } from 'app/services/contentful/add-protocol-to-url'
import { MainPageHeader } from 'components/main-page-header/main-page-header'

import { CPButton } from '../button/button'
import { type IllusProps, type PageProps } from '../types'

import css from './hero-section.module.css'

type HeroSectionProps = {
    page: PageProps
}
function HeroSection({ page }: HeroSectionProps) {
    const { header } = page.fields

    const buttons: ReactNode[] = []
    let bottomButton: ReactNode | null = null

    if (header?.fields.buttonRow) {
        const buttonRow = header.fields.buttonRow

        buttons.push(
            ...buttonRow.map((button, i: number) => {
                if (!button) return null
                return <CPButton key={i} {...button} />
            }),
        )
    }

    if (header?.fields.bottomButton) {
        bottomButton = <CPButton {...header.fields.bottomButton} />
    }

    return (
        <Box className={css.wrapper}>
            {header?.fields.illustration ? (
                <Illustration props={header.fields.illustration} />
            ) : null}
            <Container width="sm">
                {header ? (
                    <MainPageHeader
                        title={header.fields.title}
                        subtitle={header.fields.subtitle}
                        buttonRow={buttons}
                        buttonBottom={bottomButton}
                        padded={false}
                    />
                ) : null}
            </Container>
        </Box>
    )
}

function Illustration({ props }: { props: IllusProps }) {
    const src = addProtocol(props.fields.file?.url)

    if (!src) return null

    return (
        <Box className={css.imageContainer}>
            <Image src={src} width={771} height={340} alt="" priority className={css.image} />
        </Box>
    )
}

export { HeroSection }
